export interface ButtonConfig {
  id?: string;
  type?: 'button' | 'submit' | 'reset';
  label?: string;
  disabled?: boolean; // disable button when true
  loading?: boolean;
  icon?: string; //Icon image path 
  iconPosition?: 'left' | 'right'; //Icon position: 'left' or 'right'
  color?: string; //Button color (primary, danger, etc.)
  size?: 'sm' | 'md' | 'lg';
  block?: boolean; //Make button full width
  ariaLabel?: string; //Accessibility label
  extraClasses?: string; //Additional CSS classes
}

export const DEFAULT_BUTTON_CONFIG: ButtonConfig = {
    id: '',
    type: 'button',
    label: '',
    disabled: false,
    loading: false,
    icon: '',
    iconPosition: 'right',  
    color: 'primary',
    size: 'md',
    block: false,
    ariaLabel: '',
    extraClasses: ''
}